<template>
    <AuthenticatedLayout>

        <nav class="p-breadcrumb p-component" aria-label="Breadcrumb">
            <ul>
                <li class="p-breadcrumb-home"><a href="/dashboard" class="p-menuitem-link"><span
                    class="p-menuitem-icon pi pi-home"></span><!----></a></li>
                <li class="p-breadcrumb-chevron pi pi-chevron-right"></li>

                <li class=""><a href="/replays" class="p-menuitem-link"><!----><span
                    class="p-menuitem-text">Replays</span></a></li>
                <li class="p-breadcrumb-chevron pi pi-chevron-right"></li>

                <li class=""><a href="#" class="p-menuitem-link"><!----><span
                    class="p-menuitem-text">Replay #{{ replayResult.id }}</span></a></li>
            </ul>
        </nav>

        <h2>Реплаи ботов</h2>

        <div class="my-2">Период: {{ timezoned(replayResult.date_start) }} - {{ timezoned(replayResult.date_end) }}
        </div>

        <replay-data-list :bot-result-data-array="replayResult.bot_result_data_array"
                          :select="selectBot"></replay-data-list>

        <div v-if="botResultData" class="mt-4">
            <div class="mb-4">
                <span class="text-2xl">{{botResultData.bot.name}}</span> {{botResultData.bot.description}}
            </div>

            <div class="mb-4 w-full">
                <Card>
                    <template #content>
<!--                        <replay-data-chart-->
<!--                            :candles="candles"-->
<!--                            :deals="botResultData.closedDeals"-->
<!--                            :indicator="botResultData.indicators"-->
<!--                            :pair="pair"-->
<!--                            :dealsChartData="dealsChartData"-->
<!--                            :candlesChartData="candlesChartData"-->
<!--                        ></replay-data-chart>-->
                        <candles-with-deals
                            :pair="pair.symbol"
                            :deals="deals"
                            :candles="candles"
                            :zeroPrice="zeroPrice"
                            :timezone="0"
                            :width="1750">
                        </candles-with-deals>
                    </template>
                </Card>
            </div>
            <replay-data-view :bot-result-data="botResultData" :replay-result-id="replayResult.id" :candles="candles"></replay-data-view>
        </div>

    </AuthenticatedLayout>
</template>


<script>
import ReplayDataList from '@/Pages/Replay/ReplayDataList'
import ReplayDataView from '@/Pages/Replay/ReplayDataView'
import ReplayDataChart from "@/Pages/Replay/ReplayDataChart";
import AuthenticatedLayout from '@/Layouts/Authenticated.vue';
import Card from 'primevue/card';
import helperMethods from '@/helpers'
import CandlesWithDeals from "@/Charts/Candles.vue";

export default {
    metaInfo() {
        return {
            "title": "Replays"
        }
    },
    components: {
        AuthenticatedLayout, ReplayDataView, ReplayDataList, ReplayDataChart, Card, CandlesWithDeals
    },
    props: {
        replayResult: Object,
        replayId: Number,

        botName: String|undefined,
        botResultData: Object|undefined,
        candles: Array|undefined,
        pair: Object|undefined,
        candlesChartData: Array|undefined,
        dealsChartData: Array|undefined,
        deals: Array|undefined,
        zeroPrice: Number|undefined
    },
    data() {
        return {
            // botResultData: {}
        }
    },
    methods: {
        ...helperMethods,
        selectBot(bot) {
            this.$inertia.visit(`/replay/${this.replayId}/${bot.name}`)
        },
    }
}
</script>

